import { confirm } from '../../../../../lib/bootbox'

export async function confirmOverwritingDuplicateIds(
  duplicateIds: Set<string>,
  entityName: string
): Promise<boolean> {
  const idsString = getPrintableDuplicateIds(duplicateIds)

  return await confirm({
    title: '❌ Something went wrong',
    message: `Bot cannot be saved!<br />Duplicate ids were found in your ${entityName}: <br />${idsString}<br /><br />We can auto-fix this issue by overwriting duplicate ids with newly generated ones, but this can lead to issues with already collected statistics for those entities. Do you want to proceed by overwriting duplicate ids?`
  })
}

function getPrintableDuplicateIds(duplicateIds: Set<string>): string {
  return Array.from(duplicateIds)
    .map(id => `<strong>"${id}"</strong>`)
    .join('<br />')
}
